import introSec from "../../../../assets/malware.jpeg";
import classrom from "../../../../assets/classrom.jpeg";
import global from "../../../../assets/global.jpeg";
import cyberDiff from "../../../../assets/malware.jpeg";
import CybersecurityProgram from "../../Shared/CybersecurityPrograms";

const MalwareForensics = () => {
  return (
    <CybersecurityProgram
      backLink="/course/cyber-security"
      heroTitle="Malware & Forensics"
      heroSubtitle="Detecting, analyzing, and investigating cyber threats to uncover the truth."
      heroImage={introSec}
      introParagraphs={[
        "Malware & Forensics is a critical field within cybersecurity that focuses on understanding malicious software and investigating digital crimes. Malware analysis helps identify threats such as viruses, worms, ransomware, and trojans, while forensics uncovers digital evidence to support incident response and legal action.",
        "At JR Institute of Information Technology (JRIIT) in Tanzania, students gain practical expertise in identifying, dissecting, and defending against malware, as well as investigating compromised systems to trace attacks and recover critical data.",
      ]}
      classroom={{
        image: classrom,
        title: "IN THE CLASSROOM",
        paragraphs: [
          "In the classroom, students study malware types, infection techniques, payload delivery methods, and evasion tactics. They also learn forensic methodologies, including evidence collection, preservation, and analysis in accordance with legal standards.",
          "Hands-on labs include malware reverse engineering, static and dynamic malware analysis, using forensic toolkits to recover deleted files, analyzing system logs, and tracing attacker footprints across networks.",
        ],
      }}
      beyondClassroom={{
        image: global,
        title: "BEYOND THE CLASSROOM",
        paragraphs: [
          "Beyond the classroom, learners participate in simulations of cyber incidents, work on forensic case studies, and engage in projects where they investigate realistic attack scenarios.",
          "Graduates of this module are prepared for careers as malware analysts, digital forensic investigators, incident response specialists, or threat intelligence researchers—high-demand roles in government, law enforcement, and private industry.",
        ],
      }}
      difference={{
        image: cyberDiff,
        title: "MALWARE & FORENSICS + THE JRIIT DIFFERENCE",
        paragraphs: [
          "What sets JRIIT apart is our applied learning environment where students not only study malware concepts but also perform real analysis and forensic investigations in a secure lab environment.",
          "Graduates leave JRIIT with both the technical skills to neutralize threats and the investigative mindset to uncover digital evidence, making them highly valued in today’s cybersecurity landscape.",
        ],
      }}
    />
  );
};

export default MalwareForensics;
